import * as React from 'react';
import styled from '@emotion/styled';

interface NumberOfResultsProps {
  totalValue: number | undefined;
  durationSearch: number;
}

const StyledDiv = styled.div`
  margin: 0 5px;
`;

const NumberOfResults = ({ totalValue, durationSearch }: NumberOfResultsProps) => (
  <StyledDiv>{`${totalValue} Results in ${durationSearch / 1000} s`}</StyledDiv>
);

export default NumberOfResults;
